import React from 'react'


const Header = () => (
  <footer className='mt4 pt2 h5 border-top border-silver'>
    <a href='https://github.com/brendansudol/card-counting-game' className='mr2 black'>Code on GitHub</a>
    <a href='https://brendansudol.com' className='black'>Made by @brensudol</a>
  </footer>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Footer.js